<mat-card class="currency-card">
    <mat-tab-group
        [(selectedIndex)]="selectedTab"
        class="currency-tabs"
        animationDuration="200ms"
    >
        <!-- Currency List Tab -->
        <mat-tab label="Currency List">
            <ng-template matTabContent>
                <div class="tab-content">
                    <div class="table-wrapper">
                        <table
                            mat-table
                            [dataSource]="dataSourceCurrency"
                        >
                            <ng-container matColumnDef="id">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                >
                                    ID
                                </th>
                                <td
                                    mat-cell
                                    *matCellDef="let element"
                                >
                                    {{ element.id }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="name">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                >
                                    Name
                                </th>
                                <td
                                    mat-cell
                                    *matCellDef="let element"
                                >
                                    {{ element.name }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="currency_code">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                >
                                    Currency Code
                                </th>
                                <td
                                    mat-cell
                                    *matCellDef="let element"
                                >
                                    {{ element.currency_code }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="round_points">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                >
                                    Round Points
                                </th>
                                <td
                                    mat-cell
                                    *matCellDef="let element"
                                >
                                    {{ element.round_points }}
                                </td>
                            </ng-container>

                            <tr
                                mat-header-row
                                *matHeaderRowDef="columnsCurrency; sticky: true"
                            ></tr>
                            <tr
                                mat-row
                                *matRowDef="let row; columns: columnsCurrency"
                                (click)="highlightRow(row)"
                                [ngClass]="{
                                    'selected-row': row.id === selectedRowId
                                }"
                                class="clickable-row"
                            ></tr>
                        </table>
                    </div>
                </div>
            </ng-template>
        </mat-tab>

        <!-- Latest XR Tab -->
        <mat-tab label="Latest Exchange Rates">
            <ng-template matTabContent>
                <div class="tab-content">
                    <div class="table-wrapper">
                        <table
                            mat-table
                            [dataSource]="dataSourceLatestXR"
                        >
                            <ng-container matColumnDef="id">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                >
                                    ID
                                </th>
                                <td
                                    mat-cell
                                    *matCellDef="let element"
                                >
                                    {{ element.id }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="base_currency">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                >
                                    Base Currency
                                </th>
                                <td
                                    mat-cell
                                    *matCellDef="let element"
                                >
                                    {{ element.base_currency }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="currency_code">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                >
                                    Display Currency
                                </th>
                                <td
                                    mat-cell
                                    *matCellDef="let element"
                                >
                                    {{ element.currency_code }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="rate">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                >
                                    Rate
                                </th>
                                <td
                                    mat-cell
                                    *matCellDef="let element"
                                >
                                    {{ element.rate }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="updated_at">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                >
                                    Updated At
                                </th>
                                <td
                                    mat-cell
                                    *matCellDef="let element"
                                >
                                    {{
                                        element.updated_at
                                            | date: 'dd/MM/yyyy HH:mm:ss'
                                    }}
                                </td>
                            </ng-container>

                            <tr
                                mat-header-row
                                *matHeaderRowDef="columnsLatestXR; sticky: true"
                            ></tr>
                            <tr
                                mat-row
                                *matRowDef="let row; columns: columnsLatestXR"
                                (click)="highlightRow(row)"
                                [ngClass]="{
                                    'selected-row': row.id === selectedRowId
                                }"
                                class="clickable-row"
                            ></tr>
                        </table>
                    </div>
                </div>
            </ng-template>
        </mat-tab>

        <!-- XR History Tab -->
        <mat-tab label="Exchange Rate History">
            <ng-template matTabContent>
                <div class="tab-content">
                    <div class="filter-section">
                        <!-- Date Filter -->
                        <div class="filter-group">
                            <mat-form-field
                                appearance="fill"
                                class="filter-field"
                            >
                                <mat-label>Date</mat-label>
                                <input
                                    matInput
                                    [matDatepicker]="picker"
                                    [(ngModel)]="selectedDate"
                                    (ngModelChange)="onDateChange()"
                                />
                                <mat-datepicker-toggle
                                    matSuffix
                                    [for]="picker"
                                ></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <!-- Display Currency Filter -->
                        <div class="filter-group">
                            <mat-form-field
                                appearance="fill"
                                class="filter-field"
                            >
                                <mat-label>Display Currency</mat-label>
                                <mat-select
                                    [(ngModel)]="selectedDisplayCcy"
                                    (selectionChange)="onDateChange()"
                                >
                                    <mat-option [value]="undefined"
                                        >All</mat-option
                                    >
                                    <mat-option
                                        *ngFor="let ccy of displayCcyArr"
                                        [value]="ccy"
                                    >
                                        {{ ccy }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <!-- Filter Actions -->
                        <div class="filter-actions">
                            <button
                                mat-flat-button
                                color="primary"
                                (click)="onDateChange()"
                                type="button"
                            >
                                <mat-icon>filter_list</mat-icon>
                                Apply
                            </button>
                            <button
                                mat-stroked-button
                                (click)="resetFilters()"
                                type="button"
                            >
                                <mat-icon>clear</mat-icon>
                                Reset
                            </button>
                        </div>
                    </div>
                    <div class="table-wrapper">
                        <table
                            mat-table
                            [dataSource]="dataSourceXR_history"
                        >
                            <tr class="filter-row">
                                <th colspan="5">
                                    <div class="table-filter-row">
                                        <mat-form-field
                                            appearance="outline"
                                            class="filter-field"
                                        >
                                            <mat-label
                                                >Display ccy filter</mat-label
                                            >
                                            <input
                                                matInput
                                                [(ngModel)]="
                                                    historyFilter.currency_code
                                                "
                                                (keyup)="applyHistoryFilter()"
                                                placeholder="Type to filter"
                                            />
                                        </mat-form-field>
                                        <mat-form-field
                                            appearance="outline"
                                            class="filter-field"
                                        >
                                            <mat-label>Rate filter</mat-label>
                                            <input
                                                matInput
                                                [(ngModel)]="historyFilter.rate"
                                                (keyup)="applyHistoryFilter()"
                                                placeholder="e.g. 1.2"
                                            />
                                        </mat-form-field>
                                        <mat-form-field
                                            appearance="outline"
                                            class="filter-field"
                                        >
                                            <mat-label>Date filter</mat-label>
                                            <input
                                                matInput
                                                [(ngModel)]="historyFilter.date"
                                                (keyup)="applyHistoryFilter()"
                                                placeholder="dd/MM/yyyy"
                                            />
                                        </mat-form-field>
                                        <button
                                            mat-stroked-button
                                            type="button"
                                            (click)="clearHistoryFilter()"
                                        >
                                            <mat-icon>clear</mat-icon>
                                            Clear
                                        </button>
                                    </div>
                                </th>
                            </tr>
                            <ng-container matColumnDef="id">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                >
                                    ID
                                </th>
                                <td
                                    mat-cell
                                    *matCellDef="let row"
                                >
                                    {{ row.id }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="base_currency">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                >
                                    Base ccy
                                </th>
                                <td
                                    mat-cell
                                    *matCellDef="let row"
                                >
                                    {{ row.base_currency }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="currency_code">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                >
                                    Display ccy
                                </th>
                                <td
                                    mat-cell
                                    *matCellDef="let row"
                                >
                                    {{ row.currency_code }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="rate">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                >
                                    Rate
                                </th>
                                <td
                                    mat-cell
                                    *matCellDef="let row"
                                >
                                    {{ row.rate }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="date">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                >
                                    Updated at
                                </th>
                                <td
                                    mat-cell
                                    *matCellDef="let row"
                                >
                                    {{ row.date | date: 'dd/MM/yyyy' }}
                                </td>
                            </ng-container>

                            <tr
                                mat-header-row
                                *matHeaderRowDef="
                                    columnsXrHistory;
                                    sticky: true
                                "
                            ></tr>
                            <tr
                                mat-row
                                *matRowDef="let row; columns: columnsXrHistory"
                                (click)="highlightRow(row)"
                                [ngClass]="{
                                    'selected-row': row.id === selectedRowId
                                }"
                            ></tr>

                            <tr
                                class="mat-row no-data-row"
                                *matNoDataRow
                            >
                                <td
                                    class="mat-cell"
                                    colspan="5"
                                >
                                    <div class="no-data-message">
                                        <mat-icon>search_off</mat-icon>
                                        <span>No data matching the filter</span>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</mat-card>
